import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import logo from "assets/img/sharifcamp.png";
import styles from "assets/jss/material-kit-react/views/learningPage.js";
import Summary from "../Sections/Summary";
const useStyles = makeStyles(styles);

export default function AboutUsPage(props) {

  const classes = useStyles();
  const { ...rest } = props;
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
    return (
      <div>
        <Header
          color="transparent"
          brand="Material Kit React"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 200,
            color: "white"
          }}
          {...rest}
        />
        <Parallax small filter image={require("assets/img/bg11.jpg")} />
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div>
            <div className={classes.container}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.top}>
                    <div>
                      <img src={logo} alt="..." className={imageClasses} />
                    </div>
                    <div className={classes.name}>
                      <h3 className={classes.title}>درباره ما</h3>
                      <h6>برگزار کننده انواع رویدادهای حضوری و آنلاین ...</h6>
                    </div>
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <Summary/>
                </GridItem>
              </GridContainer>
              <div className={classes.description}>
                <p>
                  {" "}
                </p>
              </div>
              <GridContainer justify="center">
              </GridContainer>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
   }
